import React from 'react';
import Helmet from 'react-helmet';
import HtmlParser from 'html-react-parser';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import ResponsiveSlider from '../../components/ResponsiveSlider'
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import '../../scss/pages/_investors.scss';
import { PATHS } from '../../utils/urls';

const defaultSettings = {
  dots: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  initialSlide: 0,

  responsive: [
    {
      breakpoint: 1150,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2
      }
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

const Home = (props) => {

    const location = props.location;

    return (
        <Layout  bodyClass="page-investors" ontouchstart>
            <SEO title="Investors | ChartHop | People Analytics, Visualized" />
            <Helmet>
                <meta
                    name="description"
                    content="Proudly backed by the best people in tech including Andreessen Horowitz, Cowboy Ventures, PeopleTech Partners and more."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Investors | ChartHop | People Analytics, Visualized" />
                <meta property="og:description" content="Proudly backed by the best people in tech including Andreessen Horowitz, Cowboy Ventures, PeopleTech Partners and more." />
                <meta property="og:image" content={`https://www.charthop.com/home/meta-investors.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Investors | ChartHop | People Analytics, Visualized" />
                <meta name="twitter:description" content="Proudly backed by the best people in tech including Andreessen Horowitz, Cowboy Ventures, PeopleTech Partners and more." />
                <meta name="twitter:image" content={`https://www.charthop.com/home/meta-investors.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />

            </Helmet>

            {/* HERO CONTENT */}
            <section className="sectionSpacing">
                <section className="d-flex flex-column contentBlock">
                    <div>
                        <h1 className="text-center">Our Investors</h1>
                        <p className="text-center header-p mb-0">Backed by the best people in tech and People tech. </p>
                    </div>
                </section>
            </section>

            {/* AVAILABLE INTEGRATIONS */}
            <section className="backgroundGradientContainer-Reverse sectionSpacing pb-0 flex-centeredColumn">
                <div className="contentBlock d-flex justify-content-between flex-wrap gridContainer">

                    <div className="fullWidthCard">
                        <div className="logoContent">
                            <div>
                                <img src={'/about/supporters/Andreessen_Horowitz_logo_stacked.svg@2x.png'} alt="a16z" />
                            </div>
                        </div>
                        <div className="testimonialContent">
                            <p>“ChartHop is the kind of HR software a <strong>deeply technical engineering leader </strong> would build if they were sick of dealing with spreadsheets to manage hundreds of engineers.”</p>
                            <div className="quoteAuthorTag">
                                <img src={'/supporters/david-ulevitch.png'} alt="David Ulevitch" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>David Ulevitch</b></p>
                                    <p className="my-0 minorBlueHeader text-left">GENERAL PARTNER</p>
                                </div>
                            </div>
                            <p className="mb-0">Read more on the <a href="https://a16z.com/2020/02/20/investing-in-charthop/" className="ctaStandard"> a16z blog</a></p>
                        </div>
                    </div>

                    <div className="oneThirdCard">
                        <div>
                            <div>
                                <img src={'/about/supporters/abstract ventures@2x.png'} alt="Abstract Ventures" />
                            </div>
                        </div>
                    </div>

                    <div className="twoThirdCard">
                        <div>
                            <p className="cardQuote">“Every operator who has gone through rapid growth will <strong>instantly</strong> understand the potential impact of ChartHop on daily decision making.”</p>
                        </div>
                        <div>
                            <div className="quoteAuthorTag">
                                <img className="circle-image" src={'/supporters/jordan-wan-new.jpg'} alt="Jordan Wan" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>Jordan Wan</b></p>
                                    <p className="my-0 minorBlueHeader text-left">PARTNER</p>
                                </div>
                            </div>
                            <div>
                                <img src={'/about/supporters/CoFound Logo - Rectangular Light Background@2x.png'} alt="CloserIQ" />
                            </div>
                        </div>
                    </div>

                    <div className="fullWidthCard-imbalanced">
                        <div className="testimonialContent">
                            <p>“The first time we saw a ChartHop demo, the value and  the why now just clicked. Planning and managing organizations, people growth and modeling org changes has been mostly manual <strong>until now</strong>  - ChartHop automagically makes it all happen in software.”</p>
                            <div className="quoteAuthorTag">
                                <img src={'/supporters/aileen-cowboy.png'} alt="Aileen Lee" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>Aileen Lee</b></p>
                                    <p className="my-0 minorBlueHeader text-left">MANAGING PARTNER</p>
                                </div>
                            </div>
                        </div>
                        <div className="logoContent">
                            <div>
                                <img src={'/supporters/cowboyVentures.png'} alt="Cowboy" />
                            </div>
                        </div>
                    </div>

                    <div className="oneThirdCard">
                        <div>
                            <div>
                                <img src={'/about/supporters/shrug@2x.png'} alt="Shrug" />
                            </div>
                        </div>
                    </div>

                    <div className="twoThirdCard">
                        <div>
                            <p className="cardQuote">“ChartHop streamlines the arcane and tedious tools that have dragged down progress for years, replacing them with a single platform that seamlessly integrates with existing systems and <b>empowers people-centric decision-making.</b>”</p>
                        </div>
                        <div>
                            <div className="quoteAuthorTag">
                                <img src={'/supporters/david-flybridge.png'} alt="David Aronoff" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>David Aronoff</b></p>
                                    <p className="my-0 minorBlueHeader text-left">PARTNER</p>
                                </div>
                            </div>
                            <div>
                                <img src={'/supporters/flybridge.png'} alt="Flybridge" />
                            </div>
                        </div>
                    </div>

                    <div className="twoThirdCard">
                        <div>
                            <p className="cardQuote">“As organizations focus on creating more diverse teams, being able to easily visualize the organization’s makeup in ChartHop makes a world of difference. <b>Data begets action.</b>”</p>
                        </div>
                        <div>
                            <div className="quoteAuthorTag mb-0">
                                <img src={'/supporters/robby-peopletech.png'} alt="Robby Peters" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>Robby Peters</b></p>
                                    <p className="my-0 minorBlueHeader text-left">CO-FOUNDER</p>
                                </div>
                            </div>
                            <div>
                                <img src={'/about/supporters/PeopleTech@2x.png'} alt="PeopleTech" />
                            </div>
                        </div>
                    </div>

                    <div className="oneThirdCard">
                        <div>
                            <div>
                                <img src={'/supporters/worklife_black.png'} alt="Worklife" />
                            </div>
                        </div>
                    </div>
                    <div className="oneThirdCard">
                        <div>
                            <div>
                                <img src={'/about/supporters/semper-virens-logo.png'} alt="Semper Virens" />
                            </div>
                        </div>
                    </div>

                    <div className="twoThirdCard">
                        <div>
                            <p className="cardQuote">"ChartHop is the best real time view into the people systems and data within growing companies that lets you model, plan and understand your team in a helpful way.</p>
                            <p className="cardQuote">How you grow your organization with new talent and cultivate an existing workforce is streamlined through a single platform that lets you see the data you need to make smart decisions.</p>
                            <p className="cardQuote">If you are quickly hiring and scaling your business, there’s no better tool than ChartHop."</p>
                        </div>
                        <div>
                            <div className="quoteAuthorTag">
                                <img src={'/supporters/eric-companyVentures.jpeg'} alt="Eric Friedman" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>Eric Friedman</b></p>
                                    <p className="my-0 minorBlueHeader text-left">VENTURE PARTNER & COO</p>
                                </div>
                            </div>
                            <div>
                                <img src={'/about/supporters/company-ventures-logo.png'} alt="CompanyVentures" />
                            </div>
                        </div>
                    </div>

                    <div className="twoThirdCard">
                        <div>
                            <p className="cardQuote">"We live and operate in a world where access to real time information on demand is table stakes, it's crazy to think that we haven't had this be the case for people teams and companies more broadly.</p>
                            <p className="cardQuote">ChartHop is finally giving organizations the access and transparency they need to successfully operate in this new world."</p>
                        </div>
                        <div>
                            <div className="quoteAuthorTag mb-0">
                                <img src={'/supporters/moshe-basement.jpeg'} alt="Moshe Lifschitz" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>Moshe Lifschitz</b></p>
                                    <p className="my-0 minorBlueHeader text-left">FOUNDER & MANAGING PARTNER</p>
                                </div>
                            </div>                            
                            <div>
                                <img src={'/about/supporters/basement-fund-logo.png'} alt="BasementFund" />
                            </div>
                        </div>
                    </div>

                    <div className="oneThirdCard">
                        <div>
                            <div>
                                <img src={'/supporters/ride-ventures-logo.png'} alt="Ride Ventures" />
                            </div>
                        </div>
                    </div>

                </div>
                <h4 className="text-center centerSpacing mb-0">Plus over 40 founders and C-level executives</h4>

                <div className="contentBlock justify-content-between flex-wrap gridContainer">
                    
                    <ResponsiveSlider 
                        elements= {[
                            <div className="vertical-third-investors width-max mb-0">
                                <div className="investor-slider-logo">
                                    <img className="slider-logo-small" src={'/supporters/better-cloud.png'} alt="Better Cloud" />
                                </div>
                                <div className="investor-slider-text">
                                    <p>ChartHop is the perfect product for companies in a world where remote work is the standard, where building diverse teams is critical and being agile as a business is the only way to thrive. </p>
                                </div>
                                <div className="investor-slider-author">
                                    <img src={'/supporters/david-politis.jpeg'} alt="David Politis" />
                                    <div className="d-flex flex-column">
                                        <p className="my-0"><b>David Politis</b></p>
                                        <p className="my-0 minorBlueHeader text-left">CEO</p>
                                    </div>
                                </div>
                            </div>,

                            <div className="vertical-third-investors width-max mb-0">
                                <div className="investor-slider-logo">
                                    <img className="slider-logo-small" src={'/supporters/linkedin.png'} alt="Linkedin" />
                                </div>
                                <div className="investor-slider-text">
                                    <p>As the former leader of a team of nearly 800 people all over the world, the organizational picture that ChartHop can easily and quickly provide is something I wish I had had nearly every day.</p>
                                    <p>I think the immediate need for leaders to have visibility across their teams has only increased with remote work becoming the norm and having diverse teams that much more urgent.</p>
                                </div>
                                <div className="investor-slider-author">
                                    <img src={'/supporters/shannon-brayton.jpeg'} alt="Shannon Brayton" />
                                    <div className="d-flex flex-column">
                                        <p className="my-0"><b>Shannon Brayton</b></p>
                                        <p className="my-0 minorBlueHeader text-left">FORMER CMO</p>
                                    </div>
                                </div>
                            </div>,

                            <div className="vertical-third-investors width-max mb-0">
                                <div className="investor-slider-logo">
                                    <img className="slider-logo-small" src={'/supporters/invision.png'} alt="Invision" />
                                </div>
                                <div className="investor-slider-text">
                                    <p>InVision is a distributed workforce across more than 40 countries around the world, so it’s always been critical for us to make intentional decisions regarding our organizational structure and employee experience. </p>
                                    <p>ChartHop was the perfect solution that supported our executives and employees in a way that was frictionless and data-driven, solving inefficiencies that we’d been facing for years. </p>
                                </div>
                                <div className="investor-slider-author">
                                    <img src={'/supporters/clark-valberg.jpeg'} alt="Clark Valberg" />
                                    <div className="d-flex flex-column">
                                        <p className="my-0"><b>Clark Valberg</b></p>
                                        <p className="my-0 minorBlueHeader text-left">CEO AND CO-FOUNDER</p>
                                        <p className="mb-0"><a>Read more </a>
                                        <a href={PATHS.HOME} target="_blank" className="ctaStandard"> here</a>
                                    </p>
                                    </div>                                    
                                </div>                                
                            </div>, 
                            
                            <div className="vertical-third-investors width-max mb-0">
                                <div className="investor-slider-logo">
                                    <img className="slider-logo-small" src={'/supporters/upstream.png'} alt="Upstream" />
                                </div>
                                <div className="investor-slider-text">
                                    <p>“<b>ChartHop will become an essential part of the business building toolkit.</b></p><p>Just like every startup uses Stripe for payments, Slack for internal communication, Google Suite for emails, Carta for cap table - so too will they be using ChartHop for running and optimizing their organization."</p>
                                </div>
                                <div className="investor-slider-author">
                                    <img className="slider-logo-small" src={'/supporters/alex-upstream.png'} alt="Alex Taub" />
                                    <div className="d-flex flex-column">
                                        <p className="my-0"><b>Alex Taub</b></p>
                                        <p className="my-0 minorBlueHeader text-left">CO-FOUNDER</p>
                                    </div>
                                </div>
                            </div>,

                            <div className="vertical-third-investors width-max mb-0">
                                <div className="investor-slider-logo">
                                    <img className="slider-logo-small" src={'/supporters/ocrolus.png'} alt="Ocrolus" />
                                </div>
                                <div className="investor-slider-text">
                                    <p>“As someone who has seen a ton of HR and people management solutions, ChartHop stands out as an incredible platform for <b>optimizing</b> a company's <b>most important asset</b> - their top talent.”</p>
                                </div>
                                <div className="investor-slider-author">
                                    <img src={'/supporters/michael-reonomy.png'} alt="Michael Manne" />
                                    <div className="d-flex flex-column">
                                        <p className="my-0"><b>Michael Manne</b></p>
                                        <p className="my-0 minorBlueHeader text-left">CRO</p>
                                    </div>
                                </div>
                            </div>,

                            <div className="vertical-third-investors width-max mb-0">
                                <div className="investor-slider-logo">
                                    <img className="slider-logo-small" src={'/supporters/babbel.png'} alt="Babbel" />
                                </div>
                                <div className="investor-slider-text">
                                    <p>“ChartHop's magic is the way it <strong>fills in the gaps</strong> between HR, finance, and operations, linking up systems that were formerly islands and creating new capabilities in place of manual processes."</p>
                                </div>
                                <div className="investor-slider-author">
                                    <img src={'/supporters/julie-babbel.png'} alt="Julie Hansen" />
                                    <div className="d-flex flex-column">
                                        <p className="my-0"><b>Julie Hansen</b></p>
                                        <p className="my-0 minorBlueHeader text-left">CEO, US</p>
                                    </div>
                                </div>
                            </div>,

                            <div className="vertical-third-investors width-max mb-0">
                                <div className="investor-slider-logo">
                                    <img className="slider-logo-big" src={'/supporters/confluent.png'} alt="Confluent" />
                                </div>
                                <div className="investor-slider-text">
                                    <p>The vast majority of most companies' costs are employee related, and until ChartHop, there wasn't an easy way to create robust metrics for leading and lagging indicators that lead to better decision making across the company. </p>
                                    <p>ChartHop is a game-changing tool to create efficiencies and enable better decision-making across the company. </p>
                                </div>
                                <div className="investor-slider-author">
                                    <img src={'/supporters/cheryl-dalrymple.jpeg'} alt="Cheryl Dalrymple" />
                                    <div className="d-flex flex-column">
                                        <p className="my-0"><b>Cheryl Dalrymple</b></p>
                                        <p className="my-0 minorBlueHeader text-left">CHIEF PEOPLE OFFICER AND HEAD OF CORPORATE DEVELOPMENT</p>
                                    </div>
                                </div>
                            </div>,                            

                            <div className="vertical-third-investors width-max mb-0">
                                <div className="investor-slider-logo">
                                    <img className="slider-logo-medium" src={'/supporters/kruze-logo.png'} alt="Kruze" />
                                </div>
                                <div className="investor-slider-text">
                                    <p>ChartHop brings clarity to your org structure - and as someone who works with hundreds of start ups, I know how important this is.</p>
                                    <p>With ChartHop, everyone in the organization can see the reporting relationships plus in-depth profiles on each team member, fostering a sense of team, belonging and accountability.</p>
                                    <p>By making the org chart accessible and visible using ChartHop, you can avoid a lot of HR headaches while fostering a sense of team, belonging and accountability.</p>
                                </div>
                                <div className="investor-slider-author">
                                    <img src={'/supporters/scott-orn.jpeg'} alt="Scott Orn" />
                                    <div className="d-flex flex-column space-bottom">
                                        <p className="my-0"><b>Scott Orn</b></p>
                                        <p className="my-0 minorBlueHeader text-left">CHIEF OPERATING OFFICER</p>
                                    </div>
                                </div>
                            </div>,

                            <div className="vertical-third-investors width-max mb-0">
                                <div className="investor-slider-logo">
                                    <img className="slider-logo-small" src={'/supporters/growth-by-design-talent.png'} alt="Growth By Design Talent" />
                                </div>
                                <div className="investor-slider-text">
                                    <p>The biggest challenge companies face during hyper growth is how to best organize teams to be successful and where to prioritize headcount growth.</p>
                                    <p>ChartHop is the first product I've seen that is focused on addressing the challenge of constantly evolving company and organizational priorities with a comprehensive platform that has all the essential integrations.</p>
                                </div>
                                <div className="investor-slider-author">
                                    <img src={'/supporters/mike-joyner.jpeg'} alt="Mike Joyner" />
                                    <div className="d-flex flex-column">
                                        <p className="my-0"><b>Mike Joyner</b></p>
                                        <p className="my-0 minorBlueHeader text-left">PARTNER</p>
                                    </div>
                                </div>
                            </div>,
                                
                            <div className="vertical-third-investors width-max mb-0">
                                <div className="investor-slider-logo">
                                    <img className="slider-logo-small" src={'/supporters/mailjoy.png'} alt="Mailjoy" />
                                </div>
                                <div className="investor-slider-text">
                                    <p>Once you try ChartHop to visualize your organization, you will never want to go back to a spreadsheet.</p>
                                    <p>ChartHop should be in every founder's toolkit.</p>
                                </div>
                                <div className="investor-slider-author">
                                    <img src={'/supporters/todd-goldberg.jpeg'} alt="Todd Goldberg" />
                                    <div className="d-flex flex-column">
                                        <p className="my-0"><b>Todd Goldberg</b></p>
                                        <p className="my-0 minorBlueHeader text-left">FOUNDER</p>
                                    </div>
                                </div>
                            </div>,                           
                            
                        ]}
                    />
                </div>
                <div className="sectionSpacing mb-bullets"> </div>
            </section>

            {/* LONG FORM */}

            <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={"company-investors-demo-bottom"} headertext={HtmlParser("<h2> See what everyone's talking about. </h2><h2>Let's chat!</h2>")}/>
            </section>
        </Layout>
    );
};


export default Home;
